import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface Hashtag {
  id: string;
  hashtag: string;
  url: string;
}

interface HashtagHeaderProps {
  data: Hashtag[];
}

/**
 * Hashtag Header Component
 * Displays animated hashtag buttons
 */
const HashtagHeader: React.FC<HashtagHeaderProps> = ({ data }) => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4 },
    },
  };

  const handleClick = (url: string) => {
    navigate(url);
  };

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="w-full py-3 bg-transparent">
      <div className="container mx-auto px-4">
        <motion.div
          className="flex flex-wrap justify-center gap-2 md:gap-3"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {data.map((item) => (
            <motion.button
              key={item.id}
              onClick={() => handleClick(item.url)}
              variants={itemVariants}
              whileHover={{
                scale: 1.05,
                backgroundColor: '#dc2626',
              }}
              className="py-1.5 px-3 md:px-4 bg-[#017e6e] text-white text-xs md:text-sm font-medium rounded-full backdrop-blur-sm transition-all duration-200 hover:shadow-lg"
            >
              {item.hashtag}
            </motion.button>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default HashtagHeader;
